import axios from 'axios';

const config = Object.assign({}, window.erpPortalApiConfig);

const _axios = axios.create(config);

_axios.interceptors.request.use(
  function(config) {
    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);

_axios.interceptors.response.use(
  function(response) {
    return response;
  },
  function(error) {
    return Promise.reject(error);
  }
);

let initialized = false;

const init = async () => {
  if (initialized) return;
  initialized = true;

  if (localStorage.getItem('erpPortalApiAuthToken')) {
    try {
      const response = await _axios({
        method: 'GET',
        url: '/v1/user/info',
        headers: {
          Authorization: `Bearer ${localStorage.getItem('erpPortalApiAuthToken')}`
        }
      });

      if (response.status == 200) {
        const url = localStorage.getItem('erpPortalApiAuthReturnUrl');
        localStorage.removeItem('erpPortalApiAuthReturnUrl');

        GnAdditionals.Notification({
          title: 'Already signed in. Redirecting...',
          type: 'success'
        });

        setTimeout(() => window.location.href = url || '/', 3000);
      }
    } catch (error) {
      localStorage.removeItem('erpPortalApiAuthToken');
    }
  }

  const contents = document.querySelectorAll('.content');
  const showContent = (className) => {
    contents.forEach((content) => {
      if (content.classList.contains(className)) {
        content.classList.add('active');
      } else {
        content.classList.remove('active');
      }
    });
  };

  function verifyRecaptcha(token) {
    _axios({
      method: 'GET',
      url: '/v1/captcha/check',
      params: {
        cid: window.erpPortalApiCompany,
        token
      }
    })
      .then(response => {
        if (response.data.success && response.data.score >= 0.5) {
          handleSubmit();
        }
      })
      .catch(function (error) {
        console.error(error);
      });
  }

  async function handleSubmit() {
    const email = form.elements['email'].value;
    const company_name = form.elements['company_name'].value;
    const first_name = form.elements['first_name'].value;
    const last_name = form.elements['last_name'].value;

    const params = {
      email,
      company_name,
      first_name,
      last_name
    }
    const button = document.getElementById('signup-widget-btn');
    const loading = document.querySelector('.login-page .loading');
    button.disabled = true;
    loading.style.display = 'block';

    // check company
    const result = await _axios({
      method: 'GET',
      url: '/v1/company/find',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('erpPortalApiAuthToken')}`
      },
      params: {
        cid: window.erpPortalApiCompany,
        company_name: company_name
      }
    });

    if (result.data.data.data.company_id || result.data.data.company_id) {
      params.company_name = result.data.data.data.company_name;
      sendSignup(params);
    } else {
      loading.style.display = 'none';
      showContent('login-page__address');
    }
  }

  async function sendSignup(params) {
    const button = document.getElementById('signup-widget-btn');
    const loading = document.querySelector('.login-page .loading');
    try {
      const response = await _axios.post('/v1/auth/signup', {
        cid: window.erpPortalApiCompany,
        ...params
      });

      if (response.data && response.data.data && response.data.data.status) {
        showContent('login-page__success');
        GnAdditionals.Notification({
          title: 'Your request has been accepted, you will receive an email with your credentials shortly. Redirecting...',
          type: 'success'
        });

        setTimeout(() => window.location.href = '/signin', 3000);
      } else {
        const title = response && response.data && response.data.data && response.data.data.message;
        throw { title };
      }
    } catch (e) {
      const title = e && e.title;
      GnAdditionals.Notification({
        title: title || 'Something went wrong please try again',
        type: 'error'
      });
      button.disabled = false;
      loading.style.display = 'none';
    }
  }

  const confirm = document.getElementById('signup-widget-confirm');
  confirm.addEventListener('click', async () => {
    const email = form.elements['email'].value;
    const company_name = form.elements['company_name'].value;
    const first_name = form.elements['first_name'].value;
    const last_name = form.elements['last_name'].value;

    const checkbox = document.getElementById('dif-address');

    const bill_address = document.getElementsByName('bill_address')[0].value;
    const bill_city = document.getElementsByName('bill_city')[0].value;
    const bill_state = document.getElementsByName('bill_state')[0].value;
    const bill_code = document.getElementsByName('bill_code')[0].value;
    const bill_country = document.getElementsByName('bill_country')[0].value;

    let ship_address = document.getElementsByName('ship_address')[0].value;
    let ship_city = document.getElementsByName('ship_city')[0].value;
    let ship_state = document.getElementsByName('ship_state')[0].value;
    let ship_code = document.getElementsByName('ship_code')[0].value;
    let ship_country = document.getElementsByName('ship_country')[0].value;

    const phone = document.getElementsByName('company_phone')[0].value;

    if (!checkbox.checked) {
      ship_address = bill_address;
      ship_city = bill_city;
      ship_state = bill_state;
      ship_code = bill_code;
      ship_country = bill_country;
    }
    const params = {
      email,
      company_name,
      first_name,
      last_name,
      phone,
      address: {
        bill: {
          address: bill_address,
          city: bill_city,
          state: bill_state,
          code: bill_code,
          country: bill_country
        },
        ship: {
          address: ship_address,
          city: ship_city,
          state: ship_state,
          code: ship_code,
          country: ship_country
        }
      }
    }

    const loading = document.querySelector('.login-page .loading');
    loading.style.display = 'block';

    sendSignup(params);

    showContent('login-page__success');
  });

  const difAddress = document.getElementById('dif-address');
  const shippingAddress = document.getElementById('shippig-address');

  difAddress.addEventListener('change', function() {
    if (difAddress.checked) {
      shippingAddress.style.display = 'block';
    } else {
      shippingAddress.style.display = 'none';
    }
  });

  const form = document.getElementById('signup-widget-form');

  // form.addEventListener('submit', async e => {
  //   e.preventDefault();
  //   const email = form.elements['email'].value;
  //   const company_name = form.elements['company_name'].value;
  //   const first_name = form.elements['first_name'].value;
  //   const last_name = form.elements['last_name'].value;
  //
  //   const params = {
  //     email,
  //     company_name,
  //     first_name,
  //     last_name
  //   }
  //   const button = document.getElementById('signup-widget-btn');
  //   const loading = document.querySelector('.login-page .loading');
  //   button.disabled = true;
  //   loading.style.display = 'block';
  //
  //   // check company
  //   const result = await _axios({
  //     method: 'GET',
  //     url: '/v1/company/find',
  //     headers: {
  //       Authorization: `Bearer ${localStorage.getItem('erpPortalApiAuthToken')}`
  //     },
  //     params: {
  //       cid: window.erpPortalApiCompany,
  //       company_name: company_name
  //     }
  //   });
  //
  //   if (result.data.company_id) {
  //     sendSignup(params);
  //   } else {
  //     loading.style.display = 'none';
  //     showContent('login-page__address');
  //   }
  // }

  form.addEventListener('submit', async e => {
    e.preventDefault();
    handleSubmit();
    // grecaptcha.ready(function() {
    //   // key for APS 6Le03NUpAAAAAJWUEvUH48SZKWE-mEM58AYEcnB_
    //   // key for Portal DEV Sandbox 3 6LdCCZIqAAAAABEUqP_k45nq_emY2oHt2iYp1EdZ
    //   grecaptcha.execute('6LdCCZIqAAAAABEUqP_k45nq_emY2oHt2iYp1EdZ', { action: 'register' }).then(function(token) {
    //     verifyRecaptcha(token);
    //   });
    // });
  });
};

export default () => {
  apos.util.widgetPlayers.signup = {
    selector: '[data-signup-widget]',
    player: function (el) {
      if (apos.adminBar) {
        const form = document.getElementById('signup-widget-form');
        form.addEventListener('submit', e => {
          e.preventDefault();
          GnAdditionals.Notification({
            title: 'Disable admin mode to activate this widget',
            type: 'error'
          });
        });
        return;
      }

      init();
    }
  };
};
